var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#727831",
    d: "M8.224 10.45c-.71 0-1.264-.553-1.264-1.26a1.25 1.25 0 0 1 1.264-1.26c.71 0 1.266.553 1.266 1.26a1.25 1.25 0 0 1-1.266 1.26zm15.573 0c-.71 0-1.265-.553-1.265-1.26a1.25 1.25 0 0 1 1.265-1.26c.71 0 1.264.553 1.264 1.26s-.555 1.26-1.264 1.26zm6.67 2.699H1.533V7.177c0-1.09.858-1.946 1.953-1.946l3.972-.003v1.28l-.165.06A2.802 2.802 0 0 0 5.427 9.19a2.795 2.795 0 0 0 2.797 2.786 2.795 2.795 0 0 0 2.798-2.786 2.8 2.8 0 0 0-1.866-2.622l-.165-.06v-1.28h14.04v1.28l-.166.06A2.801 2.801 0 0 0 21 9.19a2.795 2.795 0 0 0 2.798 2.786 2.795 2.795 0 0 0 2.797-2.786c0-1.169-.75-2.223-1.866-2.622l-.166-.06v-1.28l3.952.003c1.095 0 1.953.855 1.953 1.946v5.972zm-1.953 17.325H3.486a1.929 1.929 0 0 1-1.953-1.946V14.674h28.934v13.854c0 1.09-.858 1.946-1.953 1.946zM3.486 3.705A3.483 3.483 0 0 0 0 7.177v21.351A3.483 3.483 0 0 0 3.486 32h25.028A3.483 3.483 0 0 0 32 28.528V7.177a3.483 3.483 0 0 0-3.486-3.472L24.562 3.7V.764a.765.765 0 0 0-1.532 0v2.935H8.99V.764a.766.766 0 0 0-1.532 0v2.935l-3.972.006z",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.61247b6d290300a22e814aa96988dd04.svg";
export { ForwardRef as ReactComponent };